import Component from '../component';

const BASE_MENTEE_STATUS_CLASS_NAME = 'menteeStatusSelect--';

export default class MenteeStatusDropdown extends Component {
  constructor(element) {
    super(...arguments);

    this.$element = $(element);
    this.url = this.$element.data('dynamic-url');

    this.updateCurrentMenteeStatus();
    this.bindEvents();
  }

  bindEvents() {
    this.handleChange = this.handleChange.bind(this);

    this.$element.on('change.MenteeStatusDropdown', this.handleChange);
  }

  unbindEvents() {
    this.$element.off('change.MenteeStatusDropdown', this.handleChange);
  }

  handleChange(_event) {
    this.removeStatusClass();
    this.updateCurrentMenteeStatus();
    this.addStatusClass();

    $.ajax({
      url: this.url,
      data: {'mentee_profile[objective]': this.$element.val()},
      method: 'put',
      dataType: 'json',
    });
  }

  updateCurrentMenteeStatus() {
    this.currentMenteeStatus = this.$element.val();
  }

  removeStatusClass() {
    this.$element.removeClass(this.buildStatusClass(this.currentMenteeStatus));
  }

  addStatusClass() {
    this.$element.addClass(this.buildStatusClass(this.currentMenteeStatus));
  }

  buildStatusClass(menteeStatus) {
    return BASE_MENTEE_STATUS_CLASS_NAME + menteeStatus;
  }
}
